export default __webpack_public_path__ + "static/media/agreement.6611756d.pdf";